import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import PagesTable from "../../components/pages_cms/PagesTable";

const PagesList = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <PagesTable />
        </WrapperSection>
    );
};

export default PagesList;
